// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"609":"57d28304","998":"57d28304"}[chunkId] + ".chunk.css";
};